import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";
import { setCookie } from "@jti/fe-common";

import { Dialog } from "../Dialog";
import { Typography } from "../Typography";

import styles from "./LoyaltySoftGate.module.scss";

const LOYALTY_SOFT_GATE_COOKIE_NAME = "loyaltySoftGateAccepted";

export type LoyaltySoftGateProps = {
  logoSrc?: string;
  title: string;
  okBtnTitle: string;
  noBtnTitle: string;
  noBtnLink: string;
  isAuthorMode?: boolean;
};

export const LoyaltySoftGate: FC<LoyaltySoftGateProps> = ({
  logoSrc,
  title,
  okBtnTitle,
  noBtnTitle,
  noBtnLink,
  isAuthorMode,
}) => {
  const onYesClick = () => {
    setCookie(LOYALTY_SOFT_GATE_COOKIE_NAME, true, "/");
    window.location.reload();
  };

  return (
    <Dialog
      isOpened={true}
      closable={false}
      noPadding={true}
      dataTestId="LoyaltySoftGate"
      backgroundBlur={100}
      withContentPadding={false}
      isUnwrapped={isAuthorMode}
    >
      <div className={styles.container}>
        {logoSrc && (
          <div className={styles.logoWrapper}>
            <img src={logoSrc} alt="logo" />
          </div>
        )}
        <Typography variant="body1" weight="light">
          {title}
        </Typography>
        <div className={styles.btns}>
          <Button variant="secondary" href={noBtnLink}>
            {noBtnTitle}
          </Button>
          <Button onClick={onYesClick}>{okBtnTitle}</Button>
        </div>
      </div>
    </Dialog>
  );
};
